import React, { useState } from 'react';
import OfferBar from '../components/OfferBar';
import Navbar from '../components/Navbar';
import RingModal from './RingModal';
import styled from 'styled-components';
import { Canvas, useFrame } from '@react-three/fiber';
import { useGLTF } from '@react-three/drei';

const PortfolioContainer = styled.div`
  padding: 1rem 2rem;
  font-family: 'Playfair Display SC', serif;
  color: #800020;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const RingItemWrapper = styled.div`
  position: relative;
  cursor: pointer;
  width: 220px;
  height: 220px;
  margin: 0 auto;
`;

function HoverSpinRing({ modelPath }) {
  const { scene } = useGLTF(modelPath);
  const ringRef = React.useRef();
  const [hovered, setHovered] = useState(false);

  // Spin on hover
  useFrame((state, delta) => {
    if (ringRef.current && hovered) {
      ringRef.current.rotation.y += 0.7 * delta;
    }
  });

  return (
    <primitive
      ref={ringRef}
      object={scene}
      scale={1.5}
      position={[0, -1, 0]}
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
    />
  );
}

export default function Portfolio() {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentModelPath, setCurrentModelPath] = useState('');

  const rings = [
    { id: 1, modelPath: '/models/diamond_ring.glb' },
    { id: 2, modelPath: '/models/diamond_ring2.glb' },
    { id: 3, modelPath: '/models/diamond_ring3.glb' },
    // Add more rings as needed
  ];

  const openRingModal = (modelPath) => {
    setCurrentModelPath(modelPath);
    setModalOpen(true);
  };

  const closeRingModal = () => {
    setModalOpen(false);
    setCurrentModelPath('');
  };

  return (
    <>
      <OfferBar />
      <Navbar />
      <PortfolioContainer>
        <h1>Example Portfolio</h1>
        <p>
          Hover over a ring to preview, click to see an interactive 3D view.
        </p>
        <Grid>
          {rings.map((ring) => (
            <RingItemWrapper key={ring.id} onClick={() => openRingModal(ring.modelPath)}>
              <Canvas style={{ width: '100%', height: '100%' }}>
                <ambientLight intensity={0.5} />
                <directionalLight position={[5, 10, 5]} />
                <HoverSpinRing modelPath={ring.modelPath} />
              </Canvas>
            </RingItemWrapper>
          ))}
        </Grid>
      </PortfolioContainer>

      <RingModal 
        isOpen={modalOpen}
        onClose={closeRingModal}
        modelPath={currentModelPath}
      />
    </>
  );
}
